declare global {
  interface Window {
    /** Injected by Telegram's in-app browser on iOS and Android. */
    TelegramWebviewProxy?: unknown;
  }
}

// User-agent markers of in-app browsers (social and wallet apps, plus the
// generic Android WebView flag). There is no feature test for "this is an
// in-app browser", so this list is best effort and will drift as apps change.
const IN_APP_UA =
  /Instagram|FBAN|FBAV|FB_IAB|Twitter|LinkedInApp|BytedanceWebview|musical_ly|\bLine\/|MetaMaskMobile|Trust\/|CoinbaseWallet|Phantom|; wv\)/i;

/**
 * Best-effort check for an in-app browser (Telegram, Instagram, wallet apps…),
 * where handing off to X / Discord and the Telegram login popup are
 * unreliable. Only ever used to show a hint — never to block anything.
 */
export function isInAppBrowser(): boolean {
  if (typeof window === 'undefined') return false;
  if (window.TelegramWebviewProxy) return true;
  return IN_APP_UA.test(navigator.userAgent);
}

/**
 * A link that asks the OS to open `url` in the user's real browser: an intent
 * on Android (no package, so the system's default browser), Safari's own
 * scheme on iOS 17+. Null when there's no known way — callers fall back to
 * copying the link. Some in-app browsers ignore both schemes.
 */
export function openInBrowserHref(url: string): string | null {
  const { host, pathname, search } = new URL(url);
  const target = `${host}${pathname}${search}`;
  const ua = navigator.userAgent;
  if (/Android/i.test(ua)) return `intent://${target}#Intent;scheme=https;end`;
  if (/iPhone|iPad|iPod/i.test(ua)) return `x-safari-https://${target}`;
  return null;
}
